import request from 'utils/request'
// 添加或者编辑
export const addM = data => request().post('exchange/rate/addM', data)

// 获取货币下拉选
export const getMoneyList = () => request().get('exchange/rate/moneyList')

// 添加或者编辑
export const add = data => request().post('exchange/rate/add', data)

// 获取表格数据
export const getTableData = data => request().post('exchange/rate/page', data)
